import { Spinner } from '@/components/ui/spinner.tsx';
import { cn } from 'cn';

export function LoadingSpinner({ compact = false }: { compact?: boolean }) {
  if (compact) {
    return (
      <div className="flex items-center justify-center p-4">
        <Spinner className="size-[22px]" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex min-h-[180px] flex-1 items-center justify-center bg-background',
        'h-full',
      )}
    >
      <Spinner className="size-7" />
    </div>
  );
}
